import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { Response } from "../index.limit";
import { ReqAddContactRecord, ReqAddLabel, ReqContactRecord, ReqCustomerInfo, ReqSetLabel, ResContactRecord, ResCustomerInfo } from "./index.limit";
export * from "./index.limit";

const { api } = baseUrl;
/**
 * 获取可见客户列表
 * @returns
 */
export const apiCustomerInfo = async (params: ReqCustomerInfo): Promise<Response<ResCustomerInfo>> => {
  return axios.get(`${api}/customer/customerInfo`, { params });
};

/** 查看更近记录 */
export const apiContactRecord = (params: ReqContactRecord): Promise<Response<ResContactRecord[]>> => {
  return axios.get(`${api}/customer/contactRecord`, { params });
};
/** 添加/更新跟进记录 */
export const apiAddContactRecord = (data: ReqAddContactRecord): Promise<Response<string>> => {
  return axios.post(`${api}/customer/addContactRecord`, data);
};
/** 删除跟进记录 */
export const apiDelContactRecord = (params: { id: number }) => {
  return axios.delete(`${api}/customer/delContactRecord`, { params });
};

export const apiAddLable = (params: ReqAddLabel): Promise<Response<string>> => {
  const str = Object.keys(params)
    .map((k) => `${k}=${params[k as keyof ReqAddLabel]}`)
    .join("&");
  return axios.post(`${api}/customer/addLable?${str}`);
};

/**
 * 获取标签合集
 */
export const apiLableList = (): Promise<Response<string[]>> => {
  return axios.get(`${api}/customer/lableList`);
};

/** 客户设置标签 */
export const apiSetLable = (data: ReqSetLabel) => {
  return axios.post(`${api}/customer/setLable`, data);
};
